export function extractFileInfo(url: string) {
  // Use URL constructor to parse the URL
  const urlObj = url;

  // Extract the file name and extension
  const fileNameWithExtension = urlObj.substring(urlObj.lastIndexOf('/') + 1);
  const lastDotIndex = fileNameWithExtension.lastIndexOf('.');

  // Determine file name and extension
  const fileName = lastDotIndex !== -1 ? fileNameWithExtension.substring(0, lastDotIndex) : fileNameWithExtension;
  const fileExtension = lastDotIndex !== -1 ? fileNameWithExtension.substring(lastDotIndex) : '';

  // Return an object with the file name and extension
  return {
    fileName: fileName,
    fileExtension: fileExtension
  };
}